// extracted by mini-css-extract-plugin
export default {"icon":"aIDeh8x2E4GuYwL2ITjn","placeHolderShimmer":"EzTuE7AI3WtBPh9H1oHr"};